import * as React from 'react';
import {Link} from 'react-router-dom';

class PageNotFound extends React.Component {
    constructer() {
        
    }
    render() {
        return (
            <div className="background-404">
    <div>
      <div className="text-404 relative">
        <h1 className="left">4</h1>
        <div className="coin">
          <div className="front"></div>
          <div className="front_b"></div>
          <div className="back"></div>
          <div className="back_b"></div>
        </div>
        <h1 className="right">4</h1>
      </div>
      <p className="sorry">Sorry, the page you are looking for cannot be found.</p>
      <Link to="/applications" className="home-link"><i className="material-icons">arrow_back</i>Take me home</Link>
    </div>
  </div>
        )
    }
}
export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/404.jsx